<template>
  <div>
    <table-title>物流详情信息</table-title>
    <div class="indent">
      <table v-if="tableShow" width="90%" border="1" class="borderColor" cellpadding="0" align="left" cellspacing="0">
        <tr>
          <td>物流编号</td>
          <td>{{dataList.logisticTaskId}}</td>
          <td>发货仓库</td>
          <td>
            <plt-dict-box :value="dataList.fromWarehouseId" namespace="bizObjects" id="warehouse" />
          </td>
          <td>收货仓库</td>
          <td>
            <plt-dict-box :value="dataList.toWarehouseId" namespace="bizObjects" id="warehouse" />
          </td>
        </tr>
        <tr>
          <td>发货方</td>
          <td>
            <plt-dict-box :value="dataList.fromMemberId" namespace="bizObjects" id="member" />
          </td>
          <td>收货方</td>
          <td>
            <plt-dict-box :value="dataList.toMemberId" namespace="bizObjects" id="member" />
          </td>
          <td>发货仓联系人</td>
          <td>
            <plt-dict-box :value="dataList.fromLinkmanId" namespace="bizObjects" id="contact" />
          </td>
        </tr>
        <tr>
          <td>收货仓联系人</td>
          <td>
            <plt-dict-box :value="dataList.toLinkmanId" namespace="bizObjects" id="contact" />
          </td>
          <td>状态</td>
          <td>
            <plt-dict-box :value="dataList.status" namespace="ENUM_MID-OPERATE-LOGISTICS" id="logisticTask.LogisticTaskStatus" />
          </td>
          <td>标的物小类</td>
          <td>
            <plt-dict-box :value="dataList.targetSubClassCode" namespace="target" id="type" />
          </td>
        </tr>
        <tr>
          <td>标的物编码</td>
          <td>
            <plt-dict-box :value="dataList.targetCode" namespace="target" id="code" />
          </td>
          <td>用途类型</td>
          <td>
            <plt-dict-box :value="dataList.purpose" namespace="ENUM_CORE-STORAGE" id='operateService.UseType' />
          </td>
          <td>品质类型</td>
          <td>
            <plt-dict-box :value="dataList.quality" namespace="ENUM_CORE-STORAGE" id='operateService.QualityType' />
          </td>
        </tr>
        <tr>
          <td>计划数量</td>
          <td>{{dataList.planQty}}</td>
          <td>出库数量</td>
          <td>{{dataList.shippingQty}}</td>
          <td>在途数量</td>
          <td>{{dataList.inTransitQty}}</td>
        </tr>
        <tr>
          <td>接收数量</td>
          <td>{{dataList.receiveQty}}</td>
          <td>丢失数量</td>
          <td>{{dataList.loseQty}}</td>
          <td>退回数量</td>
          <td>{{dataList.returnQty}}</td>
        </tr>
        <tr>
          <td>承办物流公司</td>
          <td>
            <plt-dict-box :value="dataList.undertakeLogisticCompanyId" namespace="bizObjects" id='member' />
          </td>
          <td>已排车数</td>
          <td>{{dataList.scheduledQty}}</td>
          <td>待确认数量</td>
          <td>{{dataList.toBeConfirmQty}}</td>
        </tr>
        <tr>
          <td>创建时间</td>
          <td colspan="1">{{new Date(dataList.createTime).Format("yyyy-MM-dd")}}</td>
          <td>所在区域</td>
          <td>
            <plt-dict-box :value="dataList.toAreaId" namespace="region" id='fullArea' />
          </td>
          <td>收货地址</td>
          <td>{{dataList.toAddr}}</td>
        </tr>
        <tr>
          <td>原业务类型</td>
          <td>
            <plt-dict-box :value="dataList.souceBizCode" namespace="logistic" id='logisticTaskCallback' />
          </td>
          <td>备注</td>
          <td colspan="3">{{dataList.remark}}</td>
        </tr>
      </table>
    </div>
    <div style="marign-top:20px;text-align:center">
      <Button type="warning" @click="$emit('on-finish')">返回</Button>
    </div>
  </div>
</template>

<script>
import tableTitle from "components/tableTitle/tableTitle.vue";

export default {
  props: ["data"],
  components: { tableTitle },
  data() {
    return {
      dataList: {},
      tableShow: false,
    };
  },
  created() {
    this.getData(this.data);
  },
  async beforeCreate() {
    await this.dict.initDict([
      {
        id: "logisticTask.LogisticTaskStatus",
        namespace: "ENUM_MID-OPERATE-LOGISTICS",
      },
      { id: "warehouse", namespace: "bizObjects" },
      { id: "contact", namespace: "bizObjects" },
    ]); // 初始化字典
  },
  methods: {
    getData(logisticTaskId) {
      let data = {
        url: "MID-OPERATE-LOGISTICS/messageService/logisticTaskService/queryLogisticTaskByTaskId",
        body: { logisticTaskId },
      };
      this.tableShow = false;
      this.invoke(data).then((res) => {
        this.dataList = res;
        this.tableShow = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.indent {
  height: 382px;
}
.borderColor {
  margin-left: 10px;
  text-align: center;
  tr {
    height: 40px;
    td {
      width: 78px;
    }
    td:nth-child(2n-1) {
      width: 90px;
      font-weight: bold;
      background: #c6e2ff;
    }
  }
}
</style>